import { cs } from "@repo/ui";
import { type FC } from "react";
import { ErrorBoundaryWithAsyncContext } from "../../../components/ErrorBoundary";
import ChangesTable from "../../../components/Profile/ChangesTable";
import { Seo } from "../../../components/SEO";
import withProtection from "../../../highOrderComponents/withProtection";

export const Title = cs.profile.changes.header;

const Changes: FC = () => {
    return (
        <ErrorBoundaryWithAsyncContext>
            <ChangesTable />
        </ErrorBoundaryWithAsyncContext>
    );
};
export default withProtection(Changes);

export const Head: FC = () => (
    <Seo title={Title}>
        <meta name="robots" content="noindex" />
    </Seo>
);
